import type { Selector, State } from 'model/State';
import { ConsentHubLinkData } from '../models/consentHub';

export const selectConsentHubLink: Selector<ConsentHubLinkData | null> = (state: State) =>
  state.mac.consentHub.consentHubLink?.ifSuccess((r) => r);
